var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Microphone_svg__clip0_48_45)",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9.75v3M.75 11.25h3M5.25.75v3M3.75 2.25h3M6.75 9a3.75 3.75 0 107.5 0 3.75 3.75 0 00-7.5 0zM7.848 11.652l5.304-5.304"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.213 9.531l4.772 4.769a2.319 2.319 0 01.094 3.276 2.319 2.319 0 01-3.276-.094l-4.772-4.772M12.75 14.432v8.818M10.5 23.25H15M16.568 5.741L21.75.75l1.5 21.669M.881 22.074l5.135-6.173"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.449 23.25c.512-.257.8-.537.8-.831 0-1.243-5.037-2.25-11.25-2.25S.75 21.176.75 22.419c0 .293.286.574.8.831"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Microphone_svg__clip0_48_45"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMicrophone;